module.exports = __webpack_public_path__ + "static/media/self-established-no.4b1b81c5.svg";